(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filter-technics-timeline"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ft-history-timeline')) {
  customElements.define('ft-history-timeline', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.ft-history__item')];
      if (this.dataset.animate !== 'true' || window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.items.forEach(item => item.classList.add('is-pending'));
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('is-pending');
            if (this.dataset.repeat !== 'true') this.observer.unobserve(entry.target);
          } else if (this.dataset.repeat === 'true') {
            entry.target.classList.add('is-pending');
          }
        });
      }, { threshold: 0.08 });
      this.items.forEach(item => this.observer.observe(item));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-category-resources"] && !Shopify.designMode) return;
  try {
    
  function initializeFtResourceLightboxes(root) {
    root.querySelectorAll('.ft-category-resources').forEach(section => {
      if (section.dataset.lightboxReady) return;
      const dialog = section.querySelector('.ftcr-lightbox');
      const links = Array.from(section.querySelectorAll('.ft-category-resources__photo-link'));
      if (!dialog || !links.length) return;
      section.dataset.lightboxReady = 'true';
      const image = dialog.querySelector('img');
      const caption = dialog.querySelector('figcaption');
      const previous = dialog.querySelector('.ftcr-lightbox__previous');
      const next = dialog.querySelector('.ftcr-lightbox__next');
      let index = 0;
      let trigger;
      function display(position) {
        index = (position + links.length) % links.length;
        image.src = links[index].href;
        image.alt = links[index].querySelector('img').alt;
        caption.textContent = links[index].closest('figure').querySelector('figcaption')?.textContent || '';
        previous.hidden = next.hidden = links.length < 2;
      }
      links.forEach((link, position) => link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        trigger = link;
        display(position);
        dialog.showModal();
      }));
      previous.addEventListener('click', () => display(index - 1));
      next.addEventListener('click', () => display(index + 1));
      dialog.querySelector('.ftcr-lightbox__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          display(index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => trigger?.focus());
    });
  }
  initializeFtResourceLightboxes(document);
  document.addEventListener('shopify:section:load', event => initializeFtResourceLightboxes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  const updateCollectionImageSizes = (section) => {
    const productList = section.querySelector('[data-ft-product-list]');
    if (!productList) return;

    const sizes = section.dataset.ftLayout === 'grid'
      ? productList.dataset.ftGridImageSizes
      : productList.dataset.ftListImageSizes;

    if (!sizes) return;

    productList.querySelectorAll('.ft-product-row__image img').forEach((image) => {
      if (image.getAttribute('sizes') !== sizes) image.setAttribute('sizes', sizes);
    });
  };

  const initializeCollectionShowcases = (scope = document) => {
    scope.querySelectorAll('.ft-collection-showcase[data-section-id]').forEach((section) => {
      if (section.dataset.ftInitialized === 'true') return;
      section.dataset.ftInitialized = 'true';

      const storageKey = 'ft-collection-layout-' + section.dataset.sectionId;
      let savedLayout = 'list';
      try {
        savedLayout = localStorage.getItem(storageKey) || 'list';
      } catch (error) {
        savedLayout = 'list';
      }
      if (savedLayout !== 'grid') savedLayout = 'list';
      section.dataset.ftLayout = savedLayout;
      section.querySelectorAll('[data-ft-view]').forEach((button) => {
        const isActive = button.dataset.ftView === savedLayout;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
      updateCollectionImageSizes(section);

      const searchForm = section.querySelector('[data-ft-search-form]');
      const searchInput = section.querySelector('[data-ft-search-input]');
      const sortForm = section.querySelector('[data-ft-sort-form]');
      const sortSelect = section.querySelector('[data-ft-sort-select]');
      const productList = section.querySelector('[data-ft-product-list]');
      if (!searchForm || !searchInput || !sortForm || !sortSelect || !productList) return;

      const initialRows = [...productList.querySelectorAll('[data-ft-search-text]')];
      const currentPage = Number.parseInt(productList.dataset.ftCurrentPage, 10) || 1;
      const totalPages = Number.parseInt(productList.dataset.ftTotalPages, 10) || 1;
      const pageSize = Number.parseInt(productList.dataset.ftPageSize, 10) || initialRows.length || 1;
      const pageParam = productList.dataset.ftPageParam || 'page';
      const defaultSort = section.dataset.ftDefaultSort || sortSelect.value;
      const pageCache = new Map([[currentPage, initialRows]]);
      const requestsInProgress = new Map();
      const pageCount = section.querySelector('[data-ft-page-count]');
      const pageCountMarkup = pageCount?.innerHTML || '';
      const searchCount = section.querySelector('[data-ft-search-count]');
      const resultCount = section.querySelector('[data-ft-result-count]');
      const resultWord = section.querySelector('[data-ft-result-word]');
      const headings = section.querySelector('.ft-collection-showcase__head');
      const pagination = section.querySelector('.ft-pagination');
      const paginationMarkup = pagination?.innerHTML || '';
      const progress = section.querySelector('[data-ft-search-progress]');
      const searchProgressLabel = progress?.textContent || '';
      const emptyState = section.querySelector('[data-ft-search-empty]');
      const clearButtons = [...section.querySelectorAll('[data-ft-clear-search]')];
      let selectedSort = defaultSort;
      let localPage = 1;
      let searchTimer = null;
      let loading = false;
      let allPagesPromise = null;

      const normalize = (value) => String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();

      const setLoading = (active) => {
        loading = active;
        searchForm.setAttribute('aria-busy', String(active));
        sortSelect.disabled = active;
        if (progress) progress.hidden = !active;
      };

      const updateAddress = (method) => {
        if (!window.location?.href || !window.history?.[method + 'State']) return;
        const address = new URL(window.location.href);
        const query = searchInput.value.trim();
        if (query) address.searchParams.set('ft_query', query);
        else address.searchParams.delete('ft_query');
        if (selectedSort !== defaultSort) {
          address.searchParams.set('sort_by', selectedSort);
          address.searchParams.delete(pageParam);
          if (localPage > 1 && !query) address.searchParams.set('ft_page', String(localPage));
          else address.searchParams.delete('ft_page');
        } else {
          address.searchParams.delete('sort_by');
          address.searchParams.delete('ft_page');
          if (currentPage > 1) address.searchParams.set(pageParam, String(currentPage));
        }
        window.history[method + 'State'](window.history.state, '', address.pathname + address.search + address.hash);
      };

      const allCachedRows = () => [...pageCache.entries()]
        .sort(([first], [second]) => first - second)
        .flatMap(([, rows]) => rows);

      const sortRows = (rows) => {
        if (selectedSort === defaultSort) return rows;
        const descending = selectedSort.endsWith('-descending');
        const compare = (first, second) => {
          if (selectedSort.startsWith('price-')) {
            return Number(first.dataset.ftPrice || 0) - Number(second.dataset.ftPrice || 0);
          }
          if (selectedSort.startsWith('created-')) {
            return Number(first.dataset.ftCreated || 0) - Number(second.dataset.ftCreated || 0);
          }
          return normalize(first.dataset.ftTitle).localeCompare(normalize(second.dataset.ftTitle), undefined, { numeric: true });
        };
        return rows.sort((first, second) => (descending ? -1 : 1) * compare(first, second));
      };

      const renderPagination = (total) => {
        if (!pagination) return;
        const paginationLinks = pagination.querySelector('.ft-pagination__links');
        if (!paginationLinks) return;
        const pageTotal = Math.ceil(total / pageSize);
        pagination.hidden = pageTotal <= 1;
        const first = (localPage - 1) * pageSize + 1;
        const last = Math.min(localPage * pageSize, total);
        const label = productList.dataset.ftOfLabel + ' ' + total + ' ' + productList.dataset.ftProductsLabel;
        const summary = pagination.querySelector('.ft-pagination__summary');
        if (summary) summary.textContent = first + '–' + last + ' ' + label;
        paginationLinks.replaceChildren();

        const button = (text, page, labelText, current = false) => {
          const item = document.createElement('button');
          item.type = 'button';
          item.textContent = text;
          item.dataset.ftLocalPage = String(page);
          item.setAttribute('aria-label', labelText);
          if (current) {
            item.classList.add('is-current');
            item.setAttribute('aria-current', 'page');
          }
          paginationLinks.appendChild(item);
        };
        if (localPage > 1) button('‹', localPage - 1, pagination.dataset.ftPreviousLabel);
        const start = Math.max(1, localPage - 2);
        const end = Math.min(pageTotal, localPage + 2);
        for (let page = start; page <= end; page += 1) button(String(page), page, String(page), page === localPage);
        if (localPage < pageTotal) button('›', localPage + 1, pagination.dataset.ftNextLabel);
      };

      const renderResults = () => {
        const terms = normalize(searchInput.value).split(/\s+/).filter(Boolean);
        const searching = terms.length > 0;
        const customSort = selectedSort !== defaultSort;
        if (customSort && pageCache.size < totalPages) return;

        const rows = searching || customSort ? allCachedRows() : initialRows;
        const matchingRows = searching
          ? rows.filter((row) => terms.every((term) => normalize(row.dataset.ftSearchText || row.textContent).includes(term)))
          : rows;
        if (customSort) sortRows(matchingRows);
        localPage = Math.min(localPage, Math.max(1, Math.ceil(matchingRows.length / pageSize)));
        const displayedRows = customSort && !searching
          ? matchingRows.slice((localPage - 1) * pageSize, localPage * pageSize)
          : matchingRows;
        productList.replaceChildren(...displayedRows);
        updateCollectionImageSizes(section);

        if (pageCount) {
          pageCount.hidden = searching;
          if (customSort && !searching) {
            const first = (localPage - 1) * pageSize + 1;
            const last = Math.min(localPage * pageSize, matchingRows.length);
            pageCount.textContent = first + '–' + last + ' ' + productList.dataset.ftOfLabel + ' ' + matchingRows.length + ' ' + productList.dataset.ftProductsLabel;
          } else if (pageCount.innerHTML !== pageCountMarkup) pageCount.innerHTML = pageCountMarkup;
        }
        if (searchCount) searchCount.hidden = !searching;
        if (resultCount) resultCount.textContent = String(matchingRows.length);
        if (resultWord) resultWord.textContent = matchingRows.length === 1 ? resultWord.dataset.singular : resultWord.dataset.plural;
        if (headings) headings.hidden = section.dataset.ftLayout === 'grid' || displayedRows.length === 0;
        if (pagination) {
          if (customSort && !searching) renderPagination(matchingRows.length);
          else {
            if (pagination.innerHTML !== paginationMarkup) pagination.innerHTML = paginationMarkup;
            pagination.hidden = searching;
          }
        }
        if (emptyState) emptyState.hidden = !searching || matchingRows.length > 0 || loading;
        clearButtons.forEach((button) => {
          if (button.classList.contains('ft-search-clear')) button.hidden = !searching;
        });
      };

      const fetchCollectionPage = (pageNumber) => {
        if (pageCache.has(pageNumber)) return Promise.resolve(pageCache.get(pageNumber));
        if (requestsInProgress.has(pageNumber)) return requestsInProgress.get(pageNumber);
        const address = new URL(window.location.href);
        address.searchParams.delete('sort_by');
        address.searchParams.delete('ft_query');
        address.searchParams.delete('ft_page');
        address.searchParams.set(pageParam, String(pageNumber));
        address.searchParams.set('section_id', section.dataset.sectionId);
        const request = fetch(address.toString(), { headers: { Accept: 'text/html' } })
          .then((response) => {
            if (!response.ok) throw new Error('Unable to load collection page.');
            return response.text();
          })
          .then((markup) => {
            const pageDocument = new DOMParser().parseFromString(markup, 'text/html');
            const rows = [...pageDocument.querySelectorAll('[data-ft-search-text]')];
            if (!rows.length) throw new Error('Collection page returned no products.');
            pageCache.set(pageNumber, rows);
            if (searchInput.value.trim() && selectedSort === defaultSort) renderResults();
            return rows;
          })
          .finally(() => requestsInProgress.delete(pageNumber));
        requestsInProgress.set(pageNumber, request);
        return request;
      };

      const ensureAllPages = () => {
        if (pageCache.size >= totalPages) return Promise.resolve(true);
        if (allPagesPromise) return allPagesPromise;
        const pages = [];
        for (let page = 1; page <= totalPages; page += 1) {
          if (!pageCache.has(page)) pages.push(page);
        }
        let nextPage = 0;
        let failed = false;
        const workers = Array.from({ length: Math.min(3, pages.length) }, async () => {
          while (nextPage < pages.length) {
            const page = pages[nextPage++];
            try {
              await fetchCollectionPage(page);
            } catch (error) {
              failed = true;
            }
          }
        });
        allPagesPromise = Promise.all(workers)
          .then(() => !failed && pageCache.size >= totalPages)
          .finally(() => { allPagesPromise = null; });
        return allPagesPromise;
      };

      const loadAndRender = async () => {
        const needsAllPages = (Boolean(searchInput.value.trim()) || selectedSort !== defaultSort) && pageCache.size < totalPages;
        if (needsAllPages) {
          if (progress) progress.textContent = selectedSort !== defaultSort ? section.dataset.ftLoadingLabel : searchProgressLabel;
          setLoading(true);
          if (selectedSort === defaultSort) renderResults();
          const success = await ensureAllPages();
          setLoading(false);
          if (!success && selectedSort !== defaultSort) {
            selectedSort = defaultSort;
            sortSelect.value = defaultSort;
            updateAddress('replace');
            if (progress) {
              progress.textContent = section.dataset.ftSortError || 'Unable to sort all products. Please try again.';
              progress.hidden = false;
            }
          }
        }
        renderResults();
      };

      section.ftRunSearch = () => {
        updateAddress('replace');
        loadAndRender();
      };
      section.ftRunSort = (value) => {
        if (![...sortSelect.options].some((option) => option.value === value)) return;
        selectedSort = value;
        localPage = 1;
        if (progress) {
          progress.textContent = section.dataset.ftLoadingLabel || progress.textContent;
          progress.hidden = true;
        }
        updateAddress('push');
        loadAndRender();
      };
      section.ftGoPage = (page) => {
        if (!Number.isInteger(page) || page < 1 || page > Math.ceil(Number(productList.dataset.ftTotalProducts) / pageSize)) return;
        localPage = page;
        updateAddress('push');
        renderResults();
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        if (searchTimer !== null) window.clearTimeout(searchTimer);
        section.ftRunSearch();
      });
      searchInput.addEventListener('input', () => {
        if (searchTimer !== null) window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(() => section.ftRunSearch(), 180);
      });
      searchInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !searchInput.value) return;
        event.preventDefault();
        searchInput.value = '';
        section.ftRunSearch();
      });
      sortForm.addEventListener('submit', (event) => {
        event.preventDefault();
        section.ftRunSort(sortSelect.value);
      });

      const restoreAddress = () => {
        const address = new URL(window.location.href);
        const requestedSort = address.searchParams.get('sort_by');
        selectedSort = [...sortSelect.options].some((option) => option.value === requestedSort) ? requestedSort : defaultSort;
        sortSelect.value = selectedSort;
        searchInput.value = address.searchParams.get('ft_query') || '';
        localPage = Math.max(1, Number.parseInt(address.searchParams.get('ft_page'), 10) || 1);
        loadAndRender();
      };
      window.addEventListener('popstate', restoreAddress);
      restoreAddress();
    });
  };

  initializeCollectionShowcases();

  document.addEventListener('click', (event) => {
    const viewButton = event.target.closest('[data-ft-view]');
    if (viewButton) {
      const section = viewButton.closest('.ft-collection-showcase[data-section-id]');
      if (!section) return;

      const layout = viewButton.dataset.ftView === 'grid' ? 'grid' : 'list';
      section.dataset.ftLayout = layout;
      section.querySelectorAll('[data-ft-view]').forEach((button) => {
        const isActive = button.dataset.ftView === layout;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      const headings = section.querySelector('.ft-collection-showcase__head');
      if (headings) {
        const visibleProducts = section.querySelectorAll('[data-ft-product-list] > [data-ft-search-text]').length;
        headings.hidden = layout === 'grid' || visibleProducts === 0;
      }
      updateCollectionImageSizes(section);

      try {
        localStorage.setItem(`ft-collection-layout-${section.dataset.sectionId}`, layout);
      } catch (error) {
      }
      return;
    }

    const clearSearchButton = event.target.closest('[data-ft-clear-search]');
    if (clearSearchButton) {
      const section = clearSearchButton.closest('.ft-collection-showcase[data-section-id]');
      const input = section?.querySelector('[data-ft-search-input]');
      if (!section || !input) return;
      input.value = '';
      section.ftRunSearch?.();
      input.focus();
      return;
    }

    const minusButton = event.target.closest('[data-ft-quantity-minus]');
    const plusButton = event.target.closest('[data-ft-quantity-plus]');
    const button = minusButton || plusButton;

    if (!button) return;

    const quantity = button.closest('[data-ft-quantity]');
    const input = quantity?.querySelector('input[type="number"]');
    if (!input) return;

    const currentValue = Number.parseInt(input.value, 10) || 1;
    input.value = minusButton ? Math.max(1, currentValue - 1) : currentValue + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (event) => {
    const sortSelect = event.target.closest('[data-ft-sort-select]');
    if (!sortSelect) return;
    const section = sortSelect.closest('.ft-collection-showcase[data-section-id]');
    section?.ftRunSort?.(sortSelect.value);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeCollectionShowcases(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-complete-projects"] && !Shopify.designMode) return;
  try {
    
  const loadProjectPhotos = async (marquee) => {
    if (marquee.dataset.ftcpLoaded) return;
    marquee.dataset.ftcpLoaded = 'true';

    const sourceUrl = new URL(marquee.dataset.projectsUrl, window.location.origin);
    if (sourceUrl.origin !== window.location.origin) return;
    const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme) sourceUrl.searchParams.set('preview_theme_id', previewTheme);

    try {
      const response = await fetch(sourceUrl.toString(), { credentials: 'same-origin', cache: 'no-cache' });
      if (!response.ok) return;
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const projects = [...page.querySelectorAll('.ft-project-card[data-project-card][data-block-id]')]
        .map((card) => ({
          id: card.dataset.blockId,
          title: card.querySelector('.ft-project-card__title')?.textContent.trim() || '',
          image: card.querySelector('.ft-project-card__media img.ft-project-card__image')
        }))
        .filter((project) => project.image?.getAttribute('src'));
      if (!projects.length) return;

      const readyProjects = (await Promise.all(projects.map(async (project) => {
        const image = new Image();
        const srcset = project.image.getAttribute('srcset');
        image.sizes = '(max-width: 600px) 195px, 330px';
        if (srcset) image.srcset = srcset;
        image.src = project.image.getAttribute('src');
        image.alt = project.image.alt || project.title;
        image.loading = 'eager';
        image.decoding = 'async';
        try {
          await image.decode();
          return { ...project, loadedImage: image };
        } catch (_error) {
          return null;
        }
      }))).filter(Boolean);
      if (!readyProjects.length) return;

      const firstGroup = document.createElement('div');
      firstGroup.className = 'ft-complete-projects__marquee-group';
      readyProjects.forEach((project) => {
        const link = document.createElement('a');
        const destination = new URL(sourceUrl.toString());
        destination.hash = `project-${encodeURIComponent(project.id)}`;
        link.href = destination.toString();
        link.className = 'ft-complete-projects__photo';
        link.setAttribute('aria-label', project.title || project.image.alt);
        link.appendChild(project.loadedImage);
        firstGroup.appendChild(link);
      });

      const count = readyProjects.length;
      const copies = count === 1 ? 8 : count === 2 ? 5 : count === 3 ? 4 : count <= 6 ? 3 : 2;
      const groups = [firstGroup];
      for (let index = 1; index < copies; index += 1) {
        const clone = firstGroup.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a').forEach((link) => { link.tabIndex = -1; });
        groups.push(clone);
      }
      const imagesReady = await Promise.all(groups.flatMap((group) => [...group.querySelectorAll('img')].map((image) => image.decode().then(() => true, () => false))));
      if (imagesReady.includes(false)) return;

      const track = marquee.querySelector('.ft-complete-projects__marquee-track');
      track.replaceChildren(...groups);
      track.style.setProperty('--ftcp-duration', `${count * Number(marquee.dataset.secondsPerPhoto || 6)}s`);
      track.style.setProperty('--ftcp-shift', `${-100 / copies}%`);
      marquee.hidden = false;
    } catch (_error) {
      marquee.hidden = true;
    }
  };

  const initProjectMarquees = (root) => {
    root.querySelectorAll('[data-ftcp-projects-source]').forEach(loadProjectPhotos);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProjectMarquees(document), { once: true });
  } else {
    initProjectMarquees(document);
  }
  document.addEventListener('shopify:section:load', (event) => initProjectMarquees(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-home-brand-partners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ft-logo-marquee')) {
  customElements.define('ft-logo-marquee', class extends HTMLElement {
    connectedCallback() {
      this.group = this.querySelector('.ft-home-brand-grid');
      this.track = this.querySelector('.ft-logo-track');
      this.viewport = this.querySelector('.ft-logo-viewport');
      this.originals = Array.from(this.group.children);
      this.media = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = false;
      this.focused = false;
      this.onChange = () => this.setup();
      this.media.addEventListener('change', this.onChange);
      this.reduced.addEventListener('change', this.onChange);
      this.onmouseenter = () => { this.hovered = true; this.sync(); };
      this.onmouseleave = () => { this.hovered = false; this.sync(); };
      this.onfocusin = () => { this.focused = true; this.sync(); };
      this.onfocusout = () => requestAnimationFrame(() => {
        this.focused = this.contains(document.activeElement);
        this.sync();
      });
      this.observer = new ResizeObserver(() => {
        const width = this.viewport.clientWidth;
        if (width !== this.lastWidth) { this.lastWidth = width; this.setup(); }
      });
      this.observer.observe(this.viewport);
      this.setup();
    }
    clone(node) {
      const copy = node.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      [copy, ...copy.querySelectorAll('*')].forEach(el => {
        el.removeAttribute('id');
        el.removeAttribute('data-shopify-editor-block');
        if (el.matches('a, button, input, [tabindex]')) el.setAttribute('tabindex', '-1');
      });
      return copy;
    }
    setup() {
      this.animation?.cancel();
      this.animation = null;
      this.track.querySelectorAll('[data-marquee-copy]').forEach(el => el.remove());
      this.group.replaceChildren(...this.originals);
      this.removeAttribute('data-active');
      let mode = this.dataset.desktop;
      if (this.media.matches && this.dataset.mobile !== 'inherit') mode = this.dataset.mobile;
      if (mode !== 'marquee' || this.reduced.matches || !this.originals.length) return;
      this.setAttribute('data-active', '');
      let repeats = 0;
      while (this.group.getBoundingClientRect().width < this.viewport.clientWidth && repeats < 30) {
        this.originals.forEach(node => this.group.append(this.clone(node)));
        repeats++;
      }
      const width = this.group.getBoundingClientRect().width;
      if (!width) return;
      const copy = this.clone(this.group);
      copy.dataset.marqueeCopy = '';
      this.track.append(copy);
      const frames = [{ transform: 'translateX(0)' }, { transform: `translateX(-${width}px)` }];
      if (this.dataset.direction === 'right') frames.reverse();
      this.animation = this.track.animate(frames, { duration: width / Math.max(5, Number(this.dataset.speed) || 35) * 1000, iterations: Infinity, easing: 'linear' });
      this.sync();
    }
    sync() {
      if (!this.animation) return;
      if (this.focused || (this.hovered && this.hasAttribute('data-pause-hover'))) this.animation.pause();
      else this.animation.play();
    }
    disconnectedCallback() {
      this.animation?.cancel();
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.onChange);
      this.reduced?.removeEventListener('change', this.onChange);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-industrial-supply"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ft-industrial-supply')) {
  customElements.define('ft-industrial-supply', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const input = this.querySelector('[data-ftis-search]');
      const empty = this.querySelector('[data-ftis-empty]');
      const items = [...this.querySelectorAll('[data-ftis-brand]')];
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      input?.addEventListener('input', () => {
        const query = normalize(input.value);
        let count = 0;
        items.forEach((item) => {
          const matches = normalize(item.textContent).includes(query);
          item.hidden = !matches;
          if (matches) count += 1;
        });
        if (empty) empty.hidden = count > 0;
      }, { signal: this.abort.signal });
      document.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest('.ftis__category');
        if (block && this.contains(block)) block.open = true;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-news-article"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ft-news-article')) {
  customElements.define('ft-news-article', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.lightboxReady) return;
      if (this.dataset.layout === 'social' && !this.dataset.assembled) this.assembleGallery();
      this.setupLightbox();
    }
    assembleGallery() {
      this.dataset.assembled = 'true';
      const content = this.querySelector('.ft-article__content');
      const footer = this.querySelector('.ft-article__footer');
      let gallery = this.querySelector('.ft-article__hero');
      const extras = Array.from(content.querySelectorAll('p > img')).filter(img => img.parentElement.children.length === 1 && img.parentElement.textContent.trim() === '');
      if (!gallery && !extras.length) return;
      if (!gallery) {
        gallery = document.createElement('figure');
        gallery.className = 'ft-article__hero';
      }
      extras.forEach(img => {
        const paragraph = img.parentElement;
        img.removeAttribute('style');
        gallery.append(img);
        paragraph.remove();
      });
      if (gallery.querySelectorAll('img').length > 1) gallery.classList.add('ft-article__hero--gallery');
      footer.before(gallery);
    }
    setupLightbox() {
      this.dataset.lightboxReady = 'true';
      this.photos = Array.from(this.querySelectorAll('.ft-article__hero img, .ft-article__content img')).filter(img => !img.closest('a, button'));
      if (!this.photos.length) return;
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'ft-photo-dialog';
      this.dialog.setAttribute('aria-label', this.dataset.galleryLabel);
      this.dialog.innerHTML = '<div class="ft-photo-dialog__toolbar"><span class="ft-photo-dialog__count" aria-live="polite"></span><button type="button" data-close>×</button></div><div class="ft-photo-dialog__stage"><button type="button" data-previous>‹</button><img alt=""><button type="button" data-next>›</button></div>';
      this.append(this.dialog);
      this.largeImage = this.dialog.querySelector('img');
      const close = this.dialog.querySelector('[data-close]');
      const previous = this.dialog.querySelector('[data-previous]');
      const next = this.dialog.querySelector('[data-next]');
      close.setAttribute('aria-label', this.dataset.closeLabel);
      previous.setAttribute('aria-label', this.dataset.previousLabel);
      next.setAttribute('aria-label', this.dataset.nextLabel);
      previous.hidden = next.hidden = this.photos.length < 2;
      close.addEventListener('click', () => this.dialog.close());
      previous.addEventListener('click', () => this.showPhoto(this.index - 1));
      next.addEventListener('click', () => this.showPhoto(this.index + 1));
      this.photos.forEach((img, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ft-photo-open';
        button.setAttribute('aria-label', this.dataset.openLabel + (img.alt ? ': ' + img.alt : ' ' + (index + 1)));
        img.before(button);
        button.append(img);
        button.addEventListener('click', () => {
          this.showPhoto(index);
          this.dialog.showModal();
        });
      });
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showPhoto(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }
      });
      this.largeImage.addEventListener('touchstart', event => {
        this.touchStart = event.touches.length === 1 ? [event.touches[0].clientX, event.touches[0].clientY] : null;
      }, {passive: true});
      this.largeImage.addEventListener('touchend', event => {
        if (!this.touchStart || event.changedTouches.length !== 1) return;
        const dx = event.changedTouches[0].clientX - this.touchStart[0];
        const dy = event.changedTouches[0].clientY - this.touchStart[1];
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) this.showPhoto(this.index + (dx < 0 ? 1 : -1));
        this.touchStart = null;
      }, {passive: true});
    }
    showPhoto(index) {
      this.index = (index + this.photos.length) % this.photos.length;
      const photo = this.photos[this.index];
      this.largeImage.src = photo.src;
      this.largeImage.alt = photo.alt || '';
      this.dialog.querySelector('.ft-photo-dialog__count').textContent = (this.index + 1) + ' / ' + this.photos.length;
    }

  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-team"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window)) return;
  const pending = new Set();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('ft-team__card--waiting');
      pending.delete(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
  const initialize = (root) => {
    if (motion.matches || window.Shopify?.designMode) return;
    root.querySelectorAll('.ft-team__card').forEach((card) => {
      if (card.dataset.ftTeamAnimated) return;
      card.dataset.ftTeamAnimated = 'true';
      card.classList.add('ft-team__card--waiting');
      pending.add(card);
      observer.observe(card);
    });
  };
  motion.addEventListener('change', () => {
    if (!motion.matches) return;
    pending.forEach((card) => {
      card.classList.remove('ft-team__card--waiting');
      observer.unobserve(card);
    });
    pending.clear();
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.ft-team__card').forEach((card) => {
      observer.unobserve(card);
      pending.delete(card);
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-video-resources"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ft-resource-video')) {
  customElements.define('ft-resource-video', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.video = this.querySelector('video');
      this.screen = this.querySelector('.ftvr__screen');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.button.addEventListener('click', () => this.toggle(), {signal});
      if (this.video) {
        this.video.addEventListener('play', () => this.label(true), {signal});
        this.video.addEventListener('pause', () => this.label(false), {signal});
        this.video.addEventListener('ended', () => this.label(false), {signal});
      }
      this.button.hidden = this.dataset.controls === 'true';
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const auto = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (this.video) {
            if (auto) this.video.play().catch(() => { this.button.hidden = false; });
          } else if (auto || this.dataset.controls === 'true') {
            this.mount(auto);
          }
          this.observer.disconnect();
        });
      }, {threshold: 0.15});
      this.observer.observe(this);
    }
    label(playing) {
      this.button.textContent = playing ? (this.video ? this.dataset.pause : this.dataset.stop) : this.dataset.play;
    }
    mount(auto) {
      if (this.querySelector('iframe')) return;
      const frame = this.querySelector('template').content.firstElementChild.cloneNode(true);
      frame.src = frame.dataset.src + '&autoplay=' + (auto ? '1' : '0');
      this.screen.append(frame);
      this.label(true);
    }
    toggle() {
      if (this.video) {
        if (this.video.paused) this.video.play().catch(() => this.label(false));
        else this.video.pause();
      } else {
        const frame = this.querySelector('iframe');
        if (frame) { frame.remove(); this.label(false); }
        else this.mount(true);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
      this.querySelector('iframe')?.remove();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
